// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-grid {
  max-width: 800px;
}

ion-button {
  margin-top: 0.5rem;
  width: 100%;
  height: 3rem;
}

.success-container {
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.success-container ion-icon {
  width: 163px;
  height: 163px;
  padding-bottom: 20px;
}

.success-content {
  max-width: 800px;
}

.logo {
  max-width: 300px;
  padding-top: 50px;
}`, "",{"version":3,"sources":["webpack://./src/app/registration/registration.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;AACJ;;AAEA;EACI,WAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AACJ;AACI;EACI,YAAA;EACA,aAAA;EACA,oBAAA;AACR;;AAGA;EACI,gBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,iBAAA;AAAJ","sourcesContent":["ion-grid {\n    max-width: 800px;\n}\n\nion-button {\n    margin-top: 0.5rem;\n    width: 100%;\n    height: 3rem;\n}\n\n.success-container {\n    width: 100%;\n    min-height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n\n    ion-icon {\n        width: 163px;\n        height: 163px;\n        padding-bottom: 20px;\n    }\n}\n\n.success-content {\n    max-width: 800px;\n}\n\n.logo {\n    max-width: 300px;\n    padding-top: 50px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
